import React from 'react';
import {  Button, Grid, TextField } from '@mui/material';
import { GetFieldData, getImages2 } from 'API/Approval/api';
import { useState } from 'react';
import { useEffect } from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { Stack } from '@mui/system';
// import SubCard from 'ui-component/cards/SubCard';
// import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
// // import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export function KeyValueComponent(props) {

  //  const[EditState,setEditState]=React.useState(true)

  // console.log("title ",data.title);

  // const handleEditStateChange =()=>{
  //     setEditState(!EditState)
  // }
  const [userData, setUserData] = useState(null)
  const [open, setOpen] = React.useState(false);
  const[ImageUrl,setImageUrl]=useState(null)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const[isLoading,setIsLoading]=useState(false)

  
  

  const handleFileOpen=(item)=>{
    console.log(item);
    console.log(props.userData.kyc_file);
    console.log(props.userData.kyc_file[item.name.toLowerCase()]);   
    getImages2(props.userData.kyc_file[item.name.toLowerCase()],setImageUrl,handleOpen,setIsLoading)
  }

  const DisplayItems = [
    {
      "name": "first_name",
      "category": "general_info",
      "Display Name": "First Name"
    },
    // {
    //   "name": "middle_name",
    //   "category": "general_info",
    //   "Display Name": "Middle Name"
    // },
    {
      "name": "last_name",
      "category": "general_info",
      "Display Name": "Last Name"
    },
    // {
    //   "name": "dob",
    //   "category": "general_info",
    //   "Display Name": "Dob"
    // },
    // {
    //   "name": "gender",
    //   "category": "general_info",
    //   "Display Name": "Gender"
    // },
    // {
    //   "name": "father",
    //   "category": "general_info",
    //   "Display Name": "Father/Spouse Name"
    // },
    // {
    //   "name": "category",
    //   "category": "general_info",
    //   "Display Name": "Category"
    // },
    // {
    //   "name": "qualification",
    //   "category": "general_info",
    //   "Display Name": "Qualification"
    // },
    
    {
      "name": "email",
      "category": "general_info",
      "Display Name": "Email Address"
    },
    {
      "name": "mobile_number",
      "category": "general_info",
      "Display Name": "Mobile Number 1"
    },
    // {
    //   "name": "mobile_number_2",
    //   "category": "general_info",
    //   "Display Name": "Mobile Number 2"
    // },

    {
      "name": "address",
      "category": "address",
      "Display Name": "Home Address"
    },
    // {
    //   "name": "home_landmark",
    //   "category": "address",
    //   "Display Name": "Land Mark"
    // },
    // {
    //   "name": "district",
    //   "category": "address",
    //   "Display Name": "Region"
    // },
    // {
    //   "name": "home_state",
    //   "category": "address",
    //   "Display Name": "State"
    // },
    {
      "name": "pin_code",
      "category": "address",
      "Display Name": "Pincode"
    },
    {
      "name": "village/town",
      "category": "address",
      "Display Name": "City / Village Name"
    },
    // {
    //   "name": "home_city",
    //   "category": "address",
    //   "Display Name": "City / Village Name"
    // },



    // {
    //   "name": "retail_address",
    //   "category": "address",
    //   "Display Name": "Retail Address"
    // },
    // {
    //   "name": "retail_landmark",
    //   "category": "address",
    //   "Display Name": "Land Mark"
    // },
    // {
    //   "name": "retail_region",
    //   "category": "address",
    //   "Display Name": "Region"
    // },
    // {
    //   "name": "retail_state",
    //   "category": "address",
    //   "Display Name": "State"
    // },
    // {
    //   "name": "retail_district",
    //   "category": "address",
    //   "Display Name": "District"
    // },
    // {
    //   "name": "retail_sub_district",
    //   "category": "address",
    //   "Display Name": "Sub District"
    // },
    // {
    //   "name": "retail_city",
    //   "category": "address",
    //   "Display Name": "City / Village Name"
    // },



    // {
    //   "name": "savings_bank_name",
    //   "category": "bank",
    //   "Display Name": "Savings A/c Bank Name"
    // },
    {
      "name": "savings_account_number",
      "category": "banking_details",
      "Display Name": "Bank Account Number"
    },

    {
      "name": "savings_holder_name",
      "category": "banking_details",
      "Display Name": "Savings A/c Holder Name"
    },
    {
      "name": "savings_ifsc_code",
      "category": "banking_details",
      "Display Name": "Savings A/c Ifsc code"
    },
    {
      "name": "od_ac_bank_name",
      "category": "banking_details",
      "Display Name": "OD A/c Bank Name"
    },
    {
      "name": "overdraft_account_number",
      "category": "banking_details",
      "Display Name": "OD Bank A/c Number"
    },
    {
      "name": "overdraft_holder_name",
      "category": "banking_details",
      "Display Name": "OD a/c holder Name"
    },
    {
      "name": "overdraft_ifsc_code",
      "category": "banking_details",
      "Display Name": "OD Bank A/c Ifsc code"
    },


    {
      "name": "aadhar_card",
      "category": "kyc_file",
      "Display Name": "Aadhaar"
    },
    {
      "name": "pancard_card",
      "category": "kyc_file",
      "Display Name": "Pan"
    },
    {
      "name": "marksheet_file",
      "category": "kyc",
      "Display Name": "10/12 Marksheet"
    },
    {
      "name": "statement_savings",
      "category": "kyc",
      "Display Name": "Statement/Passbook copy/Cheque -savings"
    },
    {
      "name": "cir_report",
      "category": "kyc",
      "Display Name": "CIR Report"
    },
    {
      "name": "statement_OD",
      "category": "kyc",
      "Display Name": "Statement/Passbook copy/Cheque -OD/CA"
    },
    {
      "name": "Address_proof",
      "category": "kyc_file",
      "Display Name": "Address Proof"
    },
    {
      "name": "ds_agreement_copy",
      "category": "kyc",
      "Display Name": "DS Agreement Copy"
    },
    {
      "name": "graduation_certificate",
      "category": "kyc_file",
      "Display Name": "Graduation Certificate"
    },
    {
      "name": "gst_certificate",
      "category": "kyc",
      "Display Name": "Gst Certificate"
    },
    {
      "name": "profile_image",
      "category": "kyc_file",
      "Display Name": "Profile Image"
    }
   
  ]



  console.log("table data", props);



  // useEffect(() => {
  //   if (props.userId && sessionStorage.getItem('UserType') === 'tm') {
  //     GetRequestById(setUserData, props.userId)
  //   }
  // }, [props.userId])


  useEffect(() => {
    if (sessionStorage.getItem('UserType') === 'ops' && props.data) {
      console.log('entered');
      const dummy = []
      // console.log();
      props.data.map(item => {
        dummy.push(item.field_name)
      })

      if (dummy.length > 0) {

        GetFieldData(setUserData, dummy, props.userId)
      }

    }
  }, [props.data])

  // const handleViewFile=(name)=>{
  //     console.log(name);
  //     console.log(userData);
  // }



  // Select List

  console.log(userData);

  return (
    <Grid container spacing={2}>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          
          <img src={ImageUrl} alt='img' style={{width:'100%'}}/>
        </Box>
      </Modal>

      {
        DisplayItems.map((item, index) => {



          return (

              (props.selected === "General Information" && item.category === "general_info")
              ||
              (props.selected === "Address" && item.category === "address")
              ||
              (props.selected === "Banking Details" && item.category === "banking_details")
              
              ?

              <Grid item xl={6} md={4} sm={12} key={index}>
                <TextField
                  label={item['Display Name']}
                  // value={userData[item['Display Name']]?userData[item['Display Name']]:Array.isArray(userData)&&userData.map((sub)=>{
                  //  return sub[item.field_name]
                  // })}  
                  value={props.userData?props.userData[item.category][item.name]:''}
                  fullWidth
                  contentEditable={false}
                />
              </Grid>
              :
              (props.selected === "KYC Details" && item.category === "kyc_file") ?
                <Grid item xl={6} md={4} sm={12} key={index}>
                  <table style={{width:'50%'}}>
                    <tr>
                      <td>{item["Display Name"]}</td>
                      <td style={{display:'flex',alignItems:'flex-end'}}><Button variant='contained' disabled={isLoading} onClick={()=>handleFileOpen(item)}>View</Button></td>
                    </tr>
                  </table>
                 
                </Grid>
                :
                null

          )

        })
      }

    </Grid>
  )



}